function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from "react";
import { ComponentBootstrap } from "@demant/react-bootstrap";
import flexSpotSchema from "@demant/react-bootstrap/lib/schemas/flex-spot";
import { v4 as uuidv4 } from "uuid";

// parser
var getTilesData = function getTilesData(elements) {
  var TAG_PREFIX = "colorful-tiles-";
  var tiles = elements.map(function (element) {
    var _items$find, _items$find2, _items$find3;
    var items = element.items;
    var image = (_items$find = items.find(function (item) {
      return item.type === "image";
    })) === null || _items$find === void 0 ? void 0 : _items$find.image.src;
    var text = (_items$find2 = items.find(function (item) {
      return item.type === "text";
    })) === null || _items$find2 === void 0 ? void 0 : _items$find2.html.html;
    var link = (_items$find3 = items.find(function (item) {
      return item.type === "link";
    })) === null || _items$find3 === void 0 ? void 0 : _items$find3.link;
    var colorTag = element.tags.find(function (tag) {
      return tag.includes("".concat(TAG_PREFIX, "color-"));
    });
    var color = colorTag ? colorTag.substring(TAG_PREFIX.length) : "color-none";
    var widthTag = element.tags.find(function (tag) {
      return tag.includes("".concat(TAG_PREFIX, "width-"));
    });
    var width = widthTag ? widthTag.substring(TAG_PREFIX.length) : "width-half";
    var uid = uuidv4();
    return {
      uid: uid,
      image: image,
      text: text,
      link: link,
      color: color,
      width: width
    };
  });
  var fullWidthsCounter = 0;
  var taggedTiles = tiles.map(function (tile, index) {
    var isFirstInRow = !((index + fullWidthsCounter) % 2);
    var taggedTile = _objectSpread(_objectSpread({}, tile), {}, {
      isFirstInRow: isFirstInRow
    });
    if (tile.width === "width-full") {
      fullWidthsCounter += 1;
    }
    return taggedTile;
  });
  return taggedTiles;
};

// actual component
var ColorfulTiles = function ColorfulTiles(_ref) {
  var settings = _ref.settings;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    tiles = _useState2[0],
    setTiles = _useState2[1];
  var elements = settings.elements;
  useEffect(function () {
    setTiles(getTilesData(elements));
  }, [elements]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, tiles.length && /*#__PURE__*/React.createElement("ul", {
    className: "element"
  }, tiles.map(function (_ref2) {
    var uid = _ref2.uid,
      image = _ref2.image,
      text = _ref2.text,
      link = _ref2.link,
      color = _ref2.color,
      width = _ref2.width,
      isFirstInRow = _ref2.isFirstInRow;
    return /*#__PURE__*/React.createElement("li", {
      key: uid,
      className: "element__item background-".concat(color, " ").concat(width, " ").concat(isFirstInRow ? "first-in-row" : ""),
      style: image && {
        backgroundImage: "url(".concat(image, ")")
      }
    }, text && /*#__PURE__*/React.createElement("div", {
      className: "element__item__text",
      dangerouslySetInnerHTML: {
        __html: text
      }
    }), link && /*#__PURE__*/React.createElement("div", {
      className: "element__item__link"
    }, /*#__PURE__*/React.createElement("a", {
      className: "disc-right",
      href: link.href,
      title: link.content || link.title,
      target: link.target
    }, /*#__PURE__*/React.createElement("span", null, "\uE603"))));
  })));
};
var myComponent = new ComponentBootstrap(".flex-spot.flexspot-colorful-tiles");
myComponent.schemaData = flexSpotSchema;
myComponent.reactApp = ColorfulTiles;
myComponent.run();